'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Badges provide quick visual identification for numeric values such as tallies and other quantities. They are not used
 * for anything other than integers. For statuses, use Lozenges. To call out tags or other high-visibility attributes,
 * use Labels.
 */
var AUIBadge = function AUIBadge(_ref) {
  var id = _ref.id,
      text = _ref.text;
  return _react2.default.createElement(
    'span',
    { className: 'aui-badge', id: id },
    text
  );
};

AUIBadge.displayName = 'AUIBadge';
AUIBadge.propTypes = {
  /**
   * Visible text of the badge (usually a number).
   */
  text: _propTypes2.default.string.isRequired,
  /**
   * ID attribute.
   */
  id: _propTypes2.default.string
};

exports.default = AUIBadge;
//# sourceMappingURL=AUIBadge.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIBadge.js
// module id = 172
// module chunks = 0